import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import UpdateDeliverySlotBlockData from '../../../Models/Content/UpdateDeliverySlotBlockData';
import UpdateDeliverySlotHolder from './UpdateDeliverySlotHolder/UpdateDeliverySlotHolder';
export default class UpdateDeliverySlotBlock extends EpiComponent<UpdateDeliverySlotBlockData> {
    public render(): ReactNode | ReactNodeArray | null {
      return (  
          <UpdateDeliverySlotHolder iContent={this.props.data}/>
      )
    }
}